import { render, staticRenderFns } from "./OldVisitTable.vue?vue&type=template&id=708bf5e8&scoped=true"
import script from "./OldVisitTable.vue?vue&type=script&lang=js"
export * from "./OldVisitTable.vue?vue&type=script&lang=js"
import style0 from "./OldVisitTable.vue?vue&type=style&index=0&id=708bf5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708bf5e8",
  null
  
)

export default component.exports